import React from 'react';

const HighlightedText = ({ text, keywords }) => {
    const highlightKeywords = (text, keywords) => {
        let keywordArray = [];
        if (typeof keywords === "string") {
            keywordArray = keywords.split(',').map(keyword => keyword.trim().toLowerCase()).filter(keyword => keyword);
        } else {
            keywordArray = keywords.map(keyword => keyword.toLowerCase());
        }

        const uniqueKeywords = Array.from(new Set(keywordArray.filter(keyword => keyword.trim() !== '')));
        const lowerCaseText = text?.toLowerCase();

        // Find positions of keywords in the original text
        const positions = [];
        uniqueKeywords.forEach(keyword => {
            let pos = lowerCaseText.indexOf(keyword);
            while (pos !== -1) {
                positions.push({ start: pos, end: pos + keyword.length, keyword });
                pos = lowerCaseText.indexOf(keyword, pos + 1);
            }
        });

        // Sort positions by start index and adjust for overlapping keywords
        positions.sort((a, b) => a.start - b.start);

        // Merge overlapping positions
        const mergedPositions = [];
        positions.forEach(pos => {
            if (mergedPositions.length === 0 || mergedPositions[mergedPositions.length - 1].end < pos.start) {
                mergedPositions.push(pos);
            } else {
                const lastPos = mergedPositions[mergedPositions.length - 1];
                lastPos.end = Math.max(lastPos.end, pos.end);
            }
        });

        let highlightedText = "";
        let lastIndex = 0;

        mergedPositions.forEach((pos, index) => {
            // highlightedText += text?.substring(lastIndex, pos.start) + '<mark>' + text?.substring(pos.start, pos.end) + '</mark>';

             //for the highlighted text orange earlier mark html tag was used now a style prop is added in it MIHIR
                        highlightedText += text?.substring(lastIndex, pos.start) + '<mark style="background-color: transparent; color: orange;">' 
+ text?.substring(pos.start, pos.end) + 
'</mark>';

            lastIndex = pos.end;
        });

        highlightedText += text?.substring(lastIndex);

        return highlightedText;
    };

    const highlightedText = highlightKeywords(text, keywords);

    return (
        <div style={{whiteSpace:"pre-wrap"}} contentEditable dangerouslySetInnerHTML={{ __html: highlightedText }} />
    );
};

export default HighlightedText;
